import { render, staticRenderFns } from "./safety-flow.vue?vue&type=template&id=b95514f8&scoped=true&"
import script from "./safety-flow.vue?vue&type=script&lang=js&"
export * from "./safety-flow.vue?vue&type=script&lang=js&"
import style0 from "./safety-flow.vue?vue&type=style&index=0&id=b95514f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95514f8",
  null
  
)

export default component.exports